// src/pages/subscription/Update.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './subscription.css'

const SubscriptionUpdate: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Stripe からこのページへリダイレクトされたあと、3秒後に管理画面へ戻る
    const timer = setTimeout(() => {
      navigate('/account/subscription');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="stripe-back" style={{ padding: 20, textAlign: 'center' }}>
      <h1 className="text-2xl font-semibold mb-4">
        autoChatAIのダッシュボードへ戻ります…
      </h1>
    </div>
  );
};

export default SubscriptionUpdate;
